import { ApiConfig } from 'src/plugins/api/declare'

const apiConfig: ApiConfig[] = [
  {
    name: 'getAppInfoByAdmin',
    method: 'POST',
    path: '/OP/AppList/GetAppInfoByAdmin',
    params: {
      AppId: ''
    },
    axiosOptions: {},
    desc: '获取应用信息'
  },
  {
    name: 'getInstallTenantExpirations',
    method: 'POST',
    path: '/OP/TenantApp/GetInstallTenantExpirations',
    params: {
      AppId: '',
      PageIndex: 1,
      PageSize: 10
    },
    axiosOptions: {},
    desc: '获取安装应用的租户列表的过期时间列表'
  },
  {
    name: 'installAppByAdmin',
    method: 'POST',
    path: '/OP/TenantApp/AddAppExpireTimeByAdmin',
    params: {
      TenantCode: '',
      AppId: '',
      ExpireTime: ''
    },
    axiosOptions: {},
    desc: '运维后台安装应用'
  },
  {
    name: 'unInstallAppByAdmin',
    method: 'POST',
    path: '/OP/TenantApp/DeleteAppExpireTimeByAdmin',
    params: {
      TenantCode: '',
      AppId: '',
    },
    axiosOptions: {},
    desc: '运维后台卸载应用'
  },
  {
    name: 'updateAppExpireTimeByAdmin',
    method: 'POST',
    path: '/OP/TenantApp/UpdateAppExpireTimeByAdmin',
    params: {
      TenantCode: '',
      AppId: '',
      ExpireTime: ''
    },
    axiosOptions: {},
    desc: '修改租户应用的到期时间(截至时间)'
  },
  {
    name: 'getPCLastVersionInfo',
    method: 'GET',
    path: '/OP/AppVersion/GetPCLastVersionInfo',
    params: {
      AppCode: '',
    },
    axiosOptions: {},
    desc: '获取应用PC端版本信息'
  },
  {
    name: 'getMobileLastVersionInfo',
    method: 'GET',
    path: '/OP/AppMobileVersion/GetMobileLastVersionInfo',
    params: {
      AppCode: '',
    },
    axiosOptions: {},
    desc: '获取应用移动端版本信息'
  },
  {
    name: 'getInstallCountInfo',
    method: 'GET',
    path: '/OP/TenantApp/GetInstallCountInfo',
    params: {
      AppCode: '',
    },
    axiosOptions: {},
    desc: '获取应用授权情况'
  },
]

export default apiConfig